import { createAsyncThunk } from "@reduxjs/toolkit";
import { updateMultiFilterByProvider } from "../../resourceExplorerSlice";
import {
  ResourceExplorerFilterItem,
  ProviderType,
} from "../../../../services/cloudchipr.api";
import { getResourceExplorerWidgetDataThunk } from "../widgets/getResourceExplorerWidgetDataThunk";
import { RootState } from "../../../store";
import { resourceExplorerFilterByKeyAndProviderSelector } from "../../selectors/filters/resourceExplorerFilterByKeyAndProviderSelector";

interface ChargeTypeFilterChangeThunkArg {
  filter: ResourceExplorerFilterItem;
  provider: ProviderType;
}

export const chargeTypeFilterChangeThunk = createAsyncThunk(
  "resourceExplorer/chargeTypeFilterChange",
  (
    { filter, provider }: ChargeTypeFilterChangeThunkArg,
    { dispatch, getState },
  ) => {
    const state = getState() as RootState;
    const currentSavedFilter = resourceExplorerFilterByKeyAndProviderSelector(
      state,
      "charge_type",
      provider,
    );
    if (!currentSavedFilter && !filter.value?.length) {
      return;
    }
    dispatch(
      updateMultiFilterByProvider({
        filter,
        provider,
      }),
    );
    dispatch(getResourceExplorerWidgetDataThunk());
  },
);
